import { createPdf, PDFReportDefinition } from "pdfmake-browserify";

export class ReportService {
  /**
   * Create a PDF report and open the PDF in a new browser tab.
   *
   * @param def the report definition; see http://pdfmake.org/index.html#/gettingstarted
   * @param options PDF creation options (see pdfkit.org)
   */
  openReport(def: PDFReportDefinition, options?: any) {
    createPdf(def).open(options || {});
  }

  /**
   * Create a PDF report and ask the browser to print it. Depending on the
   * browser, this will either open the print preview or the print dialog.
   *
   * @param def the report definition; see http://pdfmake.org/index.html#/gettingstarted
   * @param options PDF creation options (see pdfkit.org)
   */
  printReport(def: PDFReportDefinition, options?: any) {
    createPdf(def).print(options || {});
  }

  /**
   * Create a PDF report let the browser download it automatically.
   *
   * @param def the report definition; see http://pdfmake.org/index.html#/gettingstarted
   * @param filename the filename of the generated PDF file
   * @param options PDF creation options (see pdfkit.org)
   */
  createAndDownloadReport(
    def: PDFReportDefinition,
    filename: string,
    options?: any,
  ) {
    createPdf(def).download(filename, () => {}, options || {});
  }
}
